// MyPage additional translations (mp.* prefix) for all 7 languages
export const mpTranslations = {
  ja: {
    mp: {
      uploaded: '登録:', cameraAdd: '撮影で追加', selectFile: 'ファイル選択', takePhoto: 'カメラ撮影',
      guides: '講習案内', browseCourses: '講習を探す', certNo: '修了証番号:',
      meetingTime: '集合日時', experience: '関連業務経験', select: '選択してください',
      showIdHistory: '過去の身分証明書を表示', showCertHistory: '過去の資格証明書を表示',
      sent: '送信済', idBack: '身分証明書（裏面）', idFront: '身分証明書（表面）',
      certBack: '資格証明書（裏面）', certFront: '資格証明書（表面）', cert: '資格',
      courseApplications: '講習申込履歴', noGuides: '講習案内はまだありません',
      trainingGuides: '講習案内', applyCourse: '講習を申し込む',
      completeToCert: '講習を受講して資格を取得しましょう',
      invoiceInfo: '請求情報', bill: '請求', certType: '証明書タイプ', set: '設定',
      prefDate3: '第3希望日', prefDate2: '第2希望日', prefDate1: '第1希望日',
      memberSince: '登録日:', pending: '発行待ち', applicantInfo: '申込者情報',
      applied: '申込日', noApplications: '申込履歴がありません', applications: '申込履歴',
      applicationCount: '申込件数', apply: '申込', submit: '申請する',
      birthDate: '生年月日', done: '済み', note: '注意事項', guide: '案内',
      valid: '有効', schedule: '日程', japan: '日本', newApplication: '新規申込',
      branch: '支店名:', bankInfo: '振込先情報', itemsToBring: '持ち物',
      myCerts: '所有資格一覧', noCerts: '所有資格はありません', certs: '所有資格',
      position: '役職', enterDates: '希望日を入力してください（最大3候補）',
      practicalConfirmed: '実技日程確定', practicalReservation: '実技予約申請',
      bookPractical: '実技予約', cannotChange: '変更不可', map: '地図',
      total: '合計', accountType: '口座種別:', accountNo: '口座番号:', accountHolder: '口座名義:',
      participantName: '受講者名', completedCourses: '受講済み講習',
      noCompletedCourses: '受講済みの講習はありません', completed: '受講済み',
      courseSchedule: '受講日程', courseDate: '受講日:', completionDate: '受講完了日',
      noCourses: '受講中の講習はありません', coursesInProgress: '受講中の講習',
      watching: '受講中', watch: '受講中', watchCourse: '受講する',
      acquired: '取得日:', certsList: '取得した資格・修了証の一覧です',
      changePhoto: '写真を変更', allCompleted: '全カリキュラム修了',
      paidDate: '入金日:', receipt: '領収書', receiptDownloaded: '領収書をダウンロードしました', receiptFailed: '領収書の発行に失敗しました', notesQuestions: '備考・質問', noteLabel: '備考:',
      personalInfo: '個人情報', pendingCertNo: '修了証番号が未登録の講習:',
      certNumber: '修了証番号', completionInfo: '修了情報', completionDateLabel: '修了年月日:',
      completedList: '修了した講習の一覧です', created: '作成済',
      companyPhone: '会社電話番号', companyPostalCode: '会社郵便番号',
      companyInfo: '会社情報', companyName: '会社名', companyAddress: '会社住所',
      venue: '会場', email: 'メール', messageOptional: 'メッセージ（任意）',
      profileSettings: 'プロフィール設定', profilePhoto: 'プロフィール写真',
      clickForDetails: 'クリックで詳細を表示', browseOnDemand: 'オンデマンド講習を探す',
      onDemandProgress: 'オンデマンド講習の受講状況です', no: 'なし',
      specialRequests: 'ご要望があればご記入ください', yes: 'あり',
      viewPdf: 'PDF表示', imageFormat: 'JPG, PNG形式（5MB以下）',
      bankName: '銀行名:', inProgress: '受講中', cancel: 'キャンセル',
      invoiceList: '請求書一覧', noInvoices: '請求書はありません',
      idBackHistory: '身分証明書（裏面）履歴', idFrontHistory: '身分証明書（表面）履歴',
      certBackHistory: '資格証明書（裏面）履歴', certFrontHistory: '資格証明書（表面）履歴',
      cardCertNote: 'カード型証明書の発行には別途手数料がかかる場合があります。詳細は事務局にお問い合わせください。',
      participantInfo: '受講者情報',
      completeVideos: '全ての動画の視聴を完了してください',
      passQuizzes: '全てのテストに合格してください',
      correctAnswer: '正解: ',
      pay: {
        selectMethod: 'お支払い方法を選択',
        bankTransfer: '銀行振込', cash: '現金', creditCard: 'カード',
        receiptRequest: '領収書の発行を希望する',
        confirmMethod: 'この方法で確定',
        cardNote: '安全な決済ページ（Stripe）へ移動します',
        payByCard: 'カードで支払う',
        chosen: '選択済み:',
        methodSaved: '支払い方法を登録しました', methodFailed: '登録に失敗しました',
        checkoutFailed: '決済の開始に失敗しました',
        paidSuccess: 'お支払いが完了しました', paidPending: '決済処理中です。反映まで少々お待ちください',
        cancelled: 'お支払いをキャンセルしました',
      },
    },
  },
  en: {
    mp: {
      uploaded: 'Uploaded:', cameraAdd: 'Camera', selectFile: 'Select file', takePhoto: 'Take photo',
      guides: 'Guides', browseCourses: 'Browse Courses', certNo: 'Certificate No:',
      meetingTime: 'Meeting Time', experience: 'Experience', select: 'Select',
      showIdHistory: 'Show ID Document History', showCertHistory: 'Show Certificate History',
      sent: 'Sent', idBack: 'ID Document (Back)', idFront: 'ID Document (Front)',
      certBack: 'Certificate (Back)', certFront: 'Certificate (Front)', cert: 'Cert',
      courseApplications: 'Course Applications', noGuides: 'No training guides yet',
      trainingGuides: 'Training Guides', applyCourse: 'Apply for a Course',
      completeToCert: 'Complete courses to get certifications',
      invoiceInfo: 'Invoice Info', bill: 'Bill', certType: 'Type', set: 'Set',
      prefDate3: 'Preferred Date 3', prefDate2: 'Preferred Date 2', prefDate1: 'Preferred Date 1',
      memberSince: 'Member since:', pending: 'Pending', applicantInfo: 'Applicant Info',
      applied: 'Applied', noApplications: 'No applications yet', applications: 'Applications',
      applicationCount: 'Applications', apply: 'Apply', submit: 'Submit',
      birthDate: 'Birth Date', done: 'Done', note: 'Note', guide: 'Guide',
      valid: 'Valid', schedule: 'Schedule', japan: 'Japan', newApplication: 'New Application',
      branch: 'Branch:', bankInfo: 'Bank Transfer Info', itemsToBring: 'Items to Bring',
      myCerts: 'My Certifications', noCerts: 'No certifications yet', certs: 'Certs',
      position: 'Position', enterDates: 'Enter your preferred dates (up to 3)',
      practicalConfirmed: 'Practical Confirmed', practicalReservation: 'Practical Training Reservation',
      bookPractical: 'Book Practical', cannotChange: 'Cannot be changed', map: 'Map',
      total: 'Total', accountType: 'Type:', accountNo: 'Account:', accountHolder: 'Holder:',
      participantName: 'Name', completedCourses: 'Completed Courses',
      noCompletedCourses: 'No completed courses yet', completed: 'Completed',
      courseSchedule: 'Schedule', courseDate: 'Completed:', completionDate: 'Completed',
      noCourses: 'No courses in progress', coursesInProgress: 'Courses in Progress',
      watching: 'Watching', watch: 'Watch', watchCourse: 'Watch',
      acquired: 'Acquired:', certsList: 'List of your certifications',
      changePhoto: 'Change Photo', allCompleted: 'All Curriculum Completed',
      paidDate: 'Paid:', receipt: 'Receipt', receiptDownloaded: 'Receipt downloaded', receiptFailed: 'Failed to issue receipt', notesQuestions: 'Notes', noteLabel: 'Note:',
      personalInfo: 'Personal Information', pendingCertNo: 'Courses pending certificate number:',
      certNumber: 'Certificate Number', completionInfo: 'Completion Info', completionDateLabel: 'Completion Date:',
      completedList: 'List of completed courses', created: 'Created',
      companyPhone: 'Company Phone', companyPostalCode: 'Company Postal Code',
      companyInfo: 'Company Information', companyName: 'Company Name', companyAddress: 'Company Address',
      venue: 'Venue', email: 'Email', messageOptional: 'Message (optional)',
      profileSettings: 'Profile Settings', profilePhoto: 'Profile Photo',
      clickForDetails: 'Click for details', browseOnDemand: 'Browse On-Demand Courses',
      onDemandProgress: 'Your on-demand course progress', no: 'No',
      specialRequests: 'Enter any special requests', yes: 'Yes',
      viewPdf: 'View PDF', imageFormat: 'JPG, PNG (max 5MB)',
      bankName: 'Bank:', inProgress: 'In progress', cancel: 'Cancel',
      invoiceList: 'Invoices', noInvoices: 'No invoices yet',
      idBackHistory: 'ID Document (Back) History', idFrontHistory: 'ID Document (Front) History',
      certBackHistory: 'Certificate (Back) History', certFrontHistory: 'Certificate (Front) History',
      cardCertNote: 'Card certificate may require additional fees. Please contact the office for details.',
      participantInfo: 'Participant Info',
      completeVideos: 'Please complete all videos first',
      passQuizzes: 'Please pass all quizzes first',
      correctAnswer: 'Correct: ',
      pay: {
        selectMethod: 'Select payment method',
        bankTransfer: 'Bank transfer', cash: 'Cash', creditCard: 'Card',
        receiptRequest: 'Request a receipt',
        confirmMethod: 'Confirm this method',
        cardNote: "You'll be taken to secure Stripe checkout",
        payByCard: 'Pay by card',
        chosen: 'Selected:',
        methodSaved: 'Payment method saved', methodFailed: 'Failed to save',
        checkoutFailed: 'Failed to start checkout',
        paidSuccess: 'Payment completed', paidPending: 'Payment is processing, please wait',
        cancelled: 'Payment cancelled',
      },
    },
  },
  pt: {
    mp: {
      uploaded: 'Enviado:', cameraAdd: 'Câmera', selectFile: 'Selecionar', takePhoto: 'Foto',
      guides: 'Guias', browseCourses: 'Ver Cursos', certNo: 'Certificado Nº:',
      meetingTime: 'Horário', experience: 'Experiência', select: 'Selecionar',
      showIdHistory: 'Ver Histórico de ID', showCertHistory: 'Ver Histórico de Certificados',
      sent: 'Enviado', idBack: 'ID (Verso)', idFront: 'ID (Frente)',
      certBack: 'Certificado (Verso)', certFront: 'Certificado (Frente)', cert: 'Cert',
      courseApplications: 'Inscrições', noGuides: 'Nenhum guia disponível',
      trainingGuides: 'Guias de Treinamento', applyCourse: 'Inscrever-se',
      completeToCert: 'Complete cursos para obter certificações',
      invoiceInfo: 'Info de Fatura', bill: 'Fatura', certType: 'Tipo', set: 'Definir',
      prefDate3: 'Data Preferida 3', prefDate2: 'Data Preferida 2', prefDate1: 'Data Preferida 1',
      memberSince: 'Membro desde:', pending: 'Pendente', applicantInfo: 'Info do Candidato',
      applied: 'Inscrito', noApplications: 'Sem inscrições', applications: 'Inscrições',
      applicationCount: 'Inscrições', apply: 'Inscrever', submit: 'Enviar',
      birthDate: 'Data de Nasc.', done: 'Feito', note: 'Nota', guide: 'Guia',
      valid: 'Válido', schedule: 'Cronograma', japan: 'Japão', newApplication: 'Nova Inscrição',
      branch: 'Agência:', bankInfo: 'Dados Bancários', itemsToBring: 'Itens Necessários',
      myCerts: 'Minhas Certificações', noCerts: 'Nenhuma certificação', certs: 'Certificações',
      position: 'Cargo', enterDates: 'Insira datas preferidas (até 3)',
      practicalConfirmed: 'Prática Confirmada', practicalReservation: 'Reserva de Prática',
      bookPractical: 'Reservar Prática', cannotChange: 'Não pode ser alterado', map: 'Mapa',
      total: 'Total', accountType: 'Tipo:', accountNo: 'Conta:', accountHolder: 'Titular:',
      participantName: 'Nome', completedCourses: 'Cursos Concluídos',
      noCompletedCourses: 'Nenhum curso concluído', completed: 'Concluído',
      courseSchedule: 'Cronograma', courseDate: 'Data:', completionDate: 'Concluído',
      noCourses: 'Nenhum curso em andamento', coursesInProgress: 'Cursos em Andamento',
      watching: 'Assistindo', watch: 'Assistir', watchCourse: 'Assistir',
      acquired: 'Obtido:', certsList: 'Lista de suas certificações',
      changePhoto: 'Alterar Foto', allCompleted: 'Todo Currículo Concluído',
      paidDate: 'Pago:', receipt: 'Recibo', receiptDownloaded: 'Recibo baixado', receiptFailed: 'Falha ao emitir recibo', notesQuestions: 'Observações', noteLabel: 'Obs:',
      personalInfo: 'Informações Pessoais', pendingCertNo: 'Cursos sem nº de certificado:',
      certNumber: 'Nº do Certificado', completionInfo: 'Info de Conclusão', completionDateLabel: 'Data de Conclusão:',
      completedList: 'Lista de cursos concluídos', created: 'Criado',
      companyPhone: 'Tel. da Empresa', companyPostalCode: 'CEP da Empresa',
      companyInfo: 'Informações da Empresa', companyName: 'Nome da Empresa', companyAddress: 'Endereço da Empresa',
      venue: 'Local', email: 'Email', messageOptional: 'Mensagem (opcional)',
      profileSettings: 'Configurações do Perfil', profilePhoto: 'Foto do Perfil',
      clickForDetails: 'Clique para detalhes', browseOnDemand: 'Ver Cursos On-Demand',
      onDemandProgress: 'Seu progresso nos cursos on-demand', no: 'Não',
      specialRequests: 'Insira solicitações especiais', yes: 'Sim',
      viewPdf: 'Ver PDF', imageFormat: 'JPG, PNG (máx. 5MB)',
      bankName: 'Banco:', inProgress: 'Em andamento', cancel: 'Cancelar',
      invoiceList: 'Faturas', noInvoices: 'Nenhuma fatura',
      idBackHistory: 'Histórico ID (Verso)', idFrontHistory: 'Histórico ID (Frente)',
      certBackHistory: 'Histórico Cert (Verso)', certFrontHistory: 'Histórico Cert (Frente)',
      cardCertNote: 'Certificado em cartão pode ter taxas adicionais. Entre em contato para detalhes.',
      participantInfo: 'Info do Participante',
      completeVideos: 'Complete todos os vídeos primeiro',
      passQuizzes: 'Passe em todos os testes primeiro',
      correctAnswer: 'Correto: ',
      pay: {
        selectMethod: 'Selecione a forma de pagamento',
        bankTransfer: 'Transferência', cash: 'Dinheiro', creditCard: 'Cartão',
        receiptRequest: 'Solicitar recibo',
        confirmMethod: 'Confirmar esta forma',
        cardNote: 'Você será direcionado ao checkout seguro do Stripe',
        payByCard: 'Pagar com cartão',
        chosen: 'Selecionado:',
        methodSaved: 'Forma de pagamento salva', methodFailed: 'Falha ao salvar',
        checkoutFailed: 'Falha ao iniciar o pagamento',
        paidSuccess: 'Pagamento concluído', paidPending: 'Pagamento em processamento, aguarde',
        cancelled: 'Pagamento cancelado',
      },
    },
  },
  id: {
    mp: {
      uploaded: 'Diunggah:', cameraAdd: 'Kamera', selectFile: 'Pilih file', takePhoto: 'Ambil foto',
      guides: 'Panduan', browseCourses: 'Lihat Kursus', certNo: 'No. Sertifikat:',
      meetingTime: 'Waktu', experience: 'Pengalaman', select: 'Pilih',
      showIdHistory: 'Lihat Riwayat ID', showCertHistory: 'Lihat Riwayat Sertifikat',
      sent: 'Terkirim', idBack: 'ID (Belakang)', idFront: 'ID (Depan)',
      certBack: 'Sertifikat (Belakang)', certFront: 'Sertifikat (Depan)', cert: 'Sert',
      courseApplications: 'Pendaftaran Kursus', noGuides: 'Belum ada panduan',
      trainingGuides: 'Panduan Pelatihan', applyCourse: 'Daftar Kursus',
      completeToCert: 'Selesaikan kursus untuk mendapatkan sertifikasi',
      invoiceInfo: 'Info Faktur', bill: 'Tagihan', certType: 'Jenis', set: 'Atur',
      prefDate3: 'Tanggal Pilihan 3', prefDate2: 'Tanggal Pilihan 2', prefDate1: 'Tanggal Pilihan 1',
      memberSince: 'Anggota sejak:', pending: 'Menunggu', applicantInfo: 'Info Pendaftar',
      applied: 'Didaftarkan', noApplications: 'Belum ada pendaftaran', applications: 'Pendaftaran',
      applicationCount: 'Pendaftaran', apply: 'Daftar', submit: 'Kirim',
      birthDate: 'Tgl Lahir', done: 'Selesai', note: 'Catatan', guide: 'Panduan',
      valid: 'Berlaku', schedule: 'Jadwal', japan: 'Jepang', newApplication: 'Pendaftaran Baru',
      branch: 'Cabang:', bankInfo: 'Info Transfer Bank', itemsToBring: 'Yang Dibawa',
      myCerts: 'Sertifikasi Saya', noCerts: 'Belum ada sertifikasi', certs: 'Sertifikasi',
      position: 'Jabatan', enterDates: 'Masukkan tanggal pilihan (maks. 3)',
      practicalConfirmed: 'Praktik Dikonfirmasi', practicalReservation: 'Reservasi Praktik',
      bookPractical: 'Pesan Praktik', cannotChange: 'Tidak dapat diubah', map: 'Peta',
      total: 'Total', accountType: 'Jenis:', accountNo: 'Rekening:', accountHolder: 'Pemilik:',
      participantName: 'Nama', completedCourses: 'Kursus Selesai',
      noCompletedCourses: 'Belum ada kursus selesai', completed: 'Selesai',
      courseSchedule: 'Jadwal', courseDate: 'Tanggal:', completionDate: 'Selesai',
      noCourses: 'Tidak ada kursus aktif', coursesInProgress: 'Kursus Berlangsung',
      watching: 'Menonton', watch: 'Tonton', watchCourse: 'Tonton',
      acquired: 'Diperoleh:', certsList: 'Daftar sertifikasi Anda',
      changePhoto: 'Ubah Foto', allCompleted: 'Semua Kurikulum Selesai',
      paidDate: 'Dibayar:', receipt: 'Kwitansi', receiptDownloaded: 'Kwitansi diunduh', receiptFailed: 'Gagal menerbitkan kwitansi', notesQuestions: 'Catatan', noteLabel: 'Catatan:',
      personalInfo: 'Informasi Pribadi', pendingCertNo: 'Kursus menunggu nomor sertifikat:',
      certNumber: 'Nomor Sertifikat', completionInfo: 'Info Penyelesaian', completionDateLabel: 'Tanggal Selesai:',
      completedList: 'Daftar kursus selesai', created: 'Dibuat',
      companyPhone: 'Telepon Perusahaan', companyPostalCode: 'Kode Pos Perusahaan',
      companyInfo: 'Info Perusahaan', companyName: 'Nama Perusahaan', companyAddress: 'Alamat Perusahaan',
      venue: 'Tempat', email: 'Email', messageOptional: 'Pesan (opsional)',
      profileSettings: 'Pengaturan Profil', profilePhoto: 'Foto Profil',
      clickForDetails: 'Klik untuk detail', browseOnDemand: 'Lihat Kursus On-Demand',
      onDemandProgress: 'Progres kursus on-demand Anda', no: 'Tidak',
      specialRequests: 'Masukkan permintaan khusus', yes: 'Ya',
      viewPdf: 'Lihat PDF', imageFormat: 'JPG, PNG (maks. 5MB)',
      bankName: 'Bank:', inProgress: 'Berlangsung', cancel: 'Batal',
      invoiceList: 'Faktur', noInvoices: 'Belum ada faktur',
      idBackHistory: 'Riwayat ID (Belakang)', idFrontHistory: 'Riwayat ID (Depan)',
      certBackHistory: 'Riwayat Sert (Belakang)', certFrontHistory: 'Riwayat Sert (Depan)',
      cardCertNote: 'Sertifikat kartu mungkin dikenakan biaya tambahan. Hubungi kantor untuk detail.',
      participantInfo: 'Info Peserta',
      completeVideos: 'Selesaikan semua video terlebih dahulu',
      passQuizzes: 'Lulus semua kuis terlebih dahulu',
      correctAnswer: 'Benar: ',
      pay: {
        selectMethod: 'Pilih metode pembayaran',
        bankTransfer: 'Transfer bank', cash: 'Tunai', creditCard: 'Kartu',
        receiptRequest: 'Minta kwitansi',
        confirmMethod: 'Konfirmasi metode ini',
        cardNote: 'Anda akan diarahkan ke checkout Stripe yang aman',
        payByCard: 'Bayar dengan kartu',
        chosen: 'Dipilih:',
        methodSaved: 'Metode pembayaran disimpan', methodFailed: 'Gagal menyimpan',
        checkoutFailed: 'Gagal memulai pembayaran',
        paidSuccess: 'Pembayaran selesai', paidPending: 'Pembayaran sedang diproses, mohon tunggu',
        cancelled: 'Pembayaran dibatalkan',
      },
    },
  },
  vi: {
    mp: {
      uploaded: 'Đã tải:', cameraAdd: 'Camera', selectFile: 'Chọn file', takePhoto: 'Chụp ảnh',
      guides: 'Hướng dẫn', browseCourses: 'Xem khóa học', certNo: 'Số chứng chỉ:',
      meetingTime: 'Thời gian', experience: 'Kinh nghiệm', select: 'Chọn',
      showIdHistory: 'Xem lịch sử ID', showCertHistory: 'Xem lịch sử chứng chỉ',
      sent: 'Đã gửi', idBack: 'ID (Sau)', idFront: 'ID (Trước)',
      certBack: 'Chứng chỉ (Sau)', certFront: 'Chứng chỉ (Trước)', cert: 'CC',
      courseApplications: 'Đăng ký khóa học', noGuides: 'Chưa có hướng dẫn',
      trainingGuides: 'Hướng dẫn đào tạo', applyCourse: 'Đăng ký khóa học',
      completeToCert: 'Hoàn thành khóa học để nhận chứng chỉ',
      invoiceInfo: 'Thông tin hóa đơn', bill: 'Hóa đơn', certType: 'Loại', set: 'Cài đặt',
      prefDate3: 'Ngày ưu tiên 3', prefDate2: 'Ngày ưu tiên 2', prefDate1: 'Ngày ưu tiên 1',
      memberSince: 'Thành viên từ:', pending: 'Đang chờ', applicantInfo: 'Thông tin đăng ký',
      applied: 'Đã đăng ký', noApplications: 'Chưa có đăng ký', applications: 'Đăng ký',
      applicationCount: 'Đăng ký', apply: 'Đăng ký', submit: 'Gửi',
      birthDate: 'Ngày sinh', done: 'Xong', note: 'Ghi chú', guide: 'Hướng dẫn',
      valid: 'Hợp lệ', schedule: 'Lịch', japan: 'Nhật Bản', newApplication: 'Đăng ký mới',
      branch: 'Chi nhánh:', bankInfo: 'Thông tin chuyển khoản', itemsToBring: 'Cần mang theo',
      myCerts: 'Chứng chỉ của tôi', noCerts: 'Chưa có chứng chỉ', certs: 'Chứng chỉ',
      position: 'Chức vụ', enterDates: 'Nhập ngày ưu tiên (tối đa 3)',
      practicalConfirmed: 'Thực hành đã xác nhận', practicalReservation: 'Đặt lịch thực hành',
      bookPractical: 'Đặt thực hành', cannotChange: 'Không thể thay đổi', map: 'Bản đồ',
      total: 'Tổng', accountType: 'Loại:', accountNo: 'Số TK:', accountHolder: 'Chủ TK:',
      participantName: 'Tên', completedCourses: 'Khóa học hoàn thành',
      noCompletedCourses: 'Chưa có khóa học hoàn thành', completed: 'Hoàn thành',
      courseSchedule: 'Lịch học', courseDate: 'Ngày:', completionDate: 'Hoàn thành',
      noCourses: 'Không có khóa học đang học', coursesInProgress: 'Khóa học đang học',
      watching: 'Đang xem', watch: 'Xem', watchCourse: 'Xem',
      acquired: 'Đạt được:', certsList: 'Danh sách chứng chỉ của bạn',
      changePhoto: 'Đổi ảnh', allCompleted: 'Hoàn thành toàn bộ',
      paidDate: 'Đã trả:', receipt: 'Biên lai', receiptDownloaded: 'Đã tải biên lai', receiptFailed: 'Không thể phát hành biên lai', notesQuestions: 'Ghi chú', noteLabel: 'Ghi chú:',
      personalInfo: 'Thông tin cá nhân', pendingCertNo: 'Khóa học chờ số chứng chỉ:',
      certNumber: 'Số chứng chỉ', completionInfo: 'Thông tin hoàn thành', completionDateLabel: 'Ngày hoàn thành:',
      completedList: 'Danh sách khóa học hoàn thành', created: 'Đã tạo',
      companyPhone: 'SĐT Công ty', companyPostalCode: 'Mã bưu điện công ty',
      companyInfo: 'Thông tin công ty', companyName: 'Tên công ty', companyAddress: 'Địa chỉ công ty',
      venue: 'Địa điểm', email: 'Email', messageOptional: 'Tin nhắn (tùy chọn)',
      profileSettings: 'Cài đặt hồ sơ', profilePhoto: 'Ảnh hồ sơ',
      clickForDetails: 'Nhấn để xem chi tiết', browseOnDemand: 'Xem khóa On-Demand',
      onDemandProgress: 'Tiến độ khóa on-demand', no: 'Không',
      specialRequests: 'Nhập yêu cầu đặc biệt', yes: 'Có',
      viewPdf: 'Xem PDF', imageFormat: 'JPG, PNG (tối đa 5MB)',
      bankName: 'Ngân hàng:', inProgress: 'Đang học', cancel: 'Hủy',
      invoiceList: 'Hóa đơn', noInvoices: 'Chưa có hóa đơn',
      idBackHistory: 'Lịch sử ID (Sau)', idFrontHistory: 'Lịch sử ID (Trước)',
      certBackHistory: 'Lịch sử CC (Sau)', certFrontHistory: 'Lịch sử CC (Trước)',
      cardCertNote: 'Chứng chỉ thẻ có thể phát sinh phí. Liên hệ văn phòng để biết chi tiết.',
      participantInfo: 'Thông tin người tham gia',
      completeVideos: 'Hãy hoàn thành tất cả video trước',
      passQuizzes: 'Hãy đạt tất cả bài kiểm tra trước',
      correctAnswer: 'Đáp án: ',
      pay: {
        selectMethod: 'Chọn phương thức thanh toán',
        bankTransfer: 'Chuyển khoản', cash: 'Tiền mặt', creditCard: 'Thẻ',
        receiptRequest: 'Yêu cầu biên lai',
        confirmMethod: 'Xác nhận phương thức này',
        cardNote: 'Bạn sẽ được chuyển đến trang thanh toán Stripe an toàn',
        payByCard: 'Thanh toán bằng thẻ',
        chosen: 'Đã chọn:',
        methodSaved: 'Đã lưu phương thức thanh toán', methodFailed: 'Lưu thất bại',
        checkoutFailed: 'Không thể bắt đầu thanh toán',
        paidSuccess: 'Thanh toán thành công', paidPending: 'Đang xử lý thanh toán, vui lòng đợi',
        cancelled: 'Đã hủy thanh toán',
      },
    },
  },
  es: {
    mp: {
      uploaded: 'Subido:', cameraAdd: 'Cámara', selectFile: 'Seleccionar', takePhoto: 'Tomar foto',
      guides: 'Guías', browseCourses: 'Ver Cursos', certNo: 'Certificado Nº:',
      meetingTime: 'Hora', experience: 'Experiencia', select: 'Seleccionar',
      showIdHistory: 'Ver Historial de ID', showCertHistory: 'Ver Historial de Certificados',
      sent: 'Enviado', idBack: 'ID (Reverso)', idFront: 'ID (Frente)',
      certBack: 'Certificado (Reverso)', certFront: 'Certificado (Frente)', cert: 'Cert',
      courseApplications: 'Inscripciones', noGuides: 'Sin guías aún',
      trainingGuides: 'Guías de Capacitación', applyCourse: 'Inscribirse',
      completeToCert: 'Complete cursos para obtener certificaciones',
      invoiceInfo: 'Info de Factura', bill: 'Factura', certType: 'Tipo', set: 'Configurar',
      prefDate3: 'Fecha Preferida 3', prefDate2: 'Fecha Preferida 2', prefDate1: 'Fecha Preferida 1',
      memberSince: 'Miembro desde:', pending: 'Pendiente', applicantInfo: 'Info del Solicitante',
      applied: 'Inscrito', noApplications: 'Sin inscripciones', applications: 'Inscripciones',
      applicationCount: 'Inscripciones', apply: 'Inscribir', submit: 'Enviar',
      birthDate: 'Fecha de Nac.', done: 'Hecho', note: 'Nota', guide: 'Guía',
      valid: 'Válido', schedule: 'Horario', japan: 'Japón', newApplication: 'Nueva Inscripción',
      branch: 'Sucursal:', bankInfo: 'Info de Transferencia', itemsToBring: 'Qué Traer',
      myCerts: 'Mis Certificaciones', noCerts: 'Sin certificaciones', certs: 'Certificaciones',
      position: 'Cargo', enterDates: 'Ingrese fechas preferidas (hasta 3)',
      practicalConfirmed: 'Práctica Confirmada', practicalReservation: 'Reserva de Práctica',
      bookPractical: 'Reservar Práctica', cannotChange: 'No se puede cambiar', map: 'Mapa',
      total: 'Total', accountType: 'Tipo:', accountNo: 'Cuenta:', accountHolder: 'Titular:',
      participantName: 'Nombre', completedCourses: 'Cursos Completados',
      noCompletedCourses: 'Sin cursos completados', completed: 'Completado',
      courseSchedule: 'Horario', courseDate: 'Fecha:', completionDate: 'Completado',
      noCourses: 'Sin cursos activos', coursesInProgress: 'Cursos en Progreso',
      watching: 'Viendo', watch: 'Ver', watchCourse: 'Ver',
      acquired: 'Obtenido:', certsList: 'Lista de sus certificaciones',
      changePhoto: 'Cambiar Foto', allCompleted: 'Todo el Currículo Completado',
      paidDate: 'Pagado:', receipt: 'Recibo', receiptDownloaded: 'Recibo descargado', receiptFailed: 'Error al emitir recibo', notesQuestions: 'Notas', noteLabel: 'Nota:',
      personalInfo: 'Información Personal', pendingCertNo: 'Cursos pendientes de nº de certificado:',
      certNumber: 'Nº de Certificado', completionInfo: 'Info de Finalización', completionDateLabel: 'Fecha de Finalización:',
      completedList: 'Lista de cursos completados', created: 'Creado',
      companyPhone: 'Tel. de Empresa', companyPostalCode: 'Código Postal de Empresa',
      companyInfo: 'Info de Empresa', companyName: 'Nombre de Empresa', companyAddress: 'Dirección de Empresa',
      venue: 'Lugar', email: 'Email', messageOptional: 'Mensaje (opcional)',
      profileSettings: 'Configuración de Perfil', profilePhoto: 'Foto de Perfil',
      clickForDetails: 'Clic para detalles', browseOnDemand: 'Ver Cursos On-Demand',
      onDemandProgress: 'Su progreso en cursos on-demand', no: 'No',
      specialRequests: 'Ingrese solicitudes especiales', yes: 'Sí',
      viewPdf: 'Ver PDF', imageFormat: 'JPG, PNG (máx. 5MB)',
      bankName: 'Banco:', inProgress: 'En progreso', cancel: 'Cancelar',
      invoiceList: 'Facturas', noInvoices: 'Sin facturas',
      idBackHistory: 'Historial ID (Reverso)', idFrontHistory: 'Historial ID (Frente)',
      certBackHistory: 'Historial Cert (Reverso)', certFrontHistory: 'Historial Cert (Frente)',
      cardCertNote: 'El certificado en tarjeta puede tener cargos adicionales. Contacte la oficina para detalles.',
      participantInfo: 'Info del Participante',
      completeVideos: 'Complete todos los videos primero',
      passQuizzes: 'Apruebe todos los cuestionarios primero',
      correctAnswer: 'Correcto: ',
      pay: {
        selectMethod: 'Seleccione el método de pago',
        bankTransfer: 'Transferencia', cash: 'Efectivo', creditCard: 'Tarjeta',
        receiptRequest: 'Solicitar recibo',
        confirmMethod: 'Confirmar este método',
        cardNote: 'Irá al pago seguro de Stripe',
        payByCard: 'Pagar con tarjeta',
        chosen: 'Seleccionado:',
        methodSaved: 'Método de pago guardado', methodFailed: 'Error al guardar',
        checkoutFailed: 'Error al iniciar el pago',
        paidSuccess: 'Pago completado', paidPending: 'Procesando el pago, espere por favor',
        cancelled: 'Pago cancelado',
      },
    },
  },
  tl: {
    mp: {
      uploaded: 'Na-upload:', cameraAdd: 'Camera', selectFile: 'Pumili ng file', takePhoto: 'Kumuha ng larawan',
      guides: 'Mga Gabay', browseCourses: 'Tingnan Kurso', certNo: 'Sertipiko No:',
      meetingTime: 'Oras', experience: 'Karanasan', select: 'Pumili',
      showIdHistory: 'Tingnan ID History', showCertHistory: 'Tingnan Cert History',
      sent: 'Naipadala', idBack: 'ID (Likod)', idFront: 'ID (Harap)',
      certBack: 'Sertipiko (Likod)', certFront: 'Sertipiko (Harap)', cert: 'Cert',
      courseApplications: 'Mga Aplikasyon', noGuides: 'Wala pang gabay',
      trainingGuides: 'Mga Gabay sa Pagsasanay', applyCourse: 'Mag-apply',
      completeToCert: 'Tapusin ang mga kurso para makakuha ng sertipikasyon',
      invoiceInfo: 'Info ng Invoice', bill: 'Singil', certType: 'Uri', set: 'Itakda',
      prefDate3: 'Gustong Petsa 3', prefDate2: 'Gustong Petsa 2', prefDate1: 'Gustong Petsa 1',
      memberSince: 'Miyembro mula:', pending: 'Naghihintay', applicantInfo: 'Info ng Nag-apply',
      applied: 'Nag-apply', noApplications: 'Wala pang aplikasyon', applications: 'Mga Aplikasyon',
      applicationCount: 'Mga Aplikasyon', apply: 'Mag-apply', submit: 'Isumite',
      birthDate: 'Kaarawan', done: 'Tapos', note: 'Nota', guide: 'Gabay',
      valid: 'Valid', schedule: 'Iskedyul', japan: 'Japan', newApplication: 'Bagong Aplikasyon',
      branch: 'Sangay:', bankInfo: 'Info sa Bank Transfer', itemsToBring: 'Dalhin',
      myCerts: 'Aking Sertipikasyon', noCerts: 'Wala pang sertipikasyon', certs: 'Sertipikasyon',
      position: 'Posisyon', enterDates: 'Ilagay ang gustong petsa (hanggang 3)',
      practicalConfirmed: 'Praktika Nakumpirma', practicalReservation: 'Reserbasyon ng Praktika',
      bookPractical: 'I-book ang Praktika', cannotChange: 'Hindi mababago', map: 'Mapa',
      total: 'Kabuuan', accountType: 'Uri:', accountNo: 'Account:', accountHolder: 'May-ari:',
      participantName: 'Pangalan', completedCourses: 'Natapos na Kurso',
      noCompletedCourses: 'Wala pang natapos na kurso', completed: 'Natapos',
      courseSchedule: 'Iskedyul', courseDate: 'Petsa:', completionDate: 'Natapos',
      noCourses: 'Walang aktibong kurso', coursesInProgress: 'Kurso na Ginagawa',
      watching: 'Nanonood', watch: 'Panoorin', watchCourse: 'Panoorin',
      acquired: 'Nakuha:', certsList: 'Listahan ng iyong sertipikasyon',
      changePhoto: 'Palitan ang Larawan', allCompleted: 'Lahat ng Kurikulum Natapos',
      paidDate: 'Binayaran:', receipt: 'Resibo', receiptDownloaded: 'Na-download ang resibo', receiptFailed: 'Nabigo ang pag-isyu ng resibo', notesQuestions: 'Mga Nota', noteLabel: 'Nota:',
      personalInfo: 'Personal na Impormasyon', pendingCertNo: 'Mga kurso na naghihintay ng numero:',
      certNumber: 'Numero ng Sertipiko', completionInfo: 'Info ng Pagtapos', completionDateLabel: 'Petsa ng Pagtapos:',
      completedList: 'Listahan ng natapos na kurso', created: 'Nagawa',
      companyPhone: 'Telepono ng Kumpanya', companyPostalCode: 'Postal Code ng Kumpanya',
      companyInfo: 'Info ng Kumpanya', companyName: 'Pangalan ng Kumpanya', companyAddress: 'Address ng Kumpanya',
      venue: 'Lugar', email: 'Email', messageOptional: 'Mensahe (opsyonal)',
      profileSettings: 'Mga Setting ng Profile', profilePhoto: 'Larawan ng Profile',
      clickForDetails: 'I-click para sa detalye', browseOnDemand: 'Tingnan On-Demand Kurso',
      onDemandProgress: 'Iyong on-demand na progreso', no: 'Hindi',
      specialRequests: 'Ilagay ang mga espesyal na kahilingan', yes: 'Oo',
      viewPdf: 'Tingnan PDF', imageFormat: 'JPG, PNG (maks. 5MB)',
      bankName: 'Bangko:', inProgress: 'Ginagawa', cancel: 'Kanselahin',
      invoiceList: 'Mga Invoice', noInvoices: 'Wala pang invoice',
      idBackHistory: 'ID (Likod) History', idFrontHistory: 'ID (Harap) History',
      certBackHistory: 'Cert (Likod) History', certFrontHistory: 'Cert (Harap) History',
      cardCertNote: 'Ang card certificate ay maaaring may karagdagang bayad. Makipag-ugnayan sa opisina.',
      participantInfo: 'Info ng Kalahok',
      completeVideos: 'Tapusin muna lahat ng video',
      passQuizzes: 'Pumasa muna sa lahat ng pagsusulit',
      correctAnswer: 'Tamang sagot: ',
      pay: {
        selectMethod: 'Pumili ng paraan ng pagbabayad',
        bankTransfer: 'Bank transfer', cash: 'Cash', creditCard: 'Card',
        receiptRequest: 'Humiling ng resibo',
        confirmMethod: 'Kumpirmahin ang paraang ito',
        cardNote: 'Dadalhin ka sa secure na Stripe checkout',
        payByCard: 'Magbayad gamit ang card',
        chosen: 'Napili:',
        methodSaved: 'Nai-save ang paraan ng pagbabayad', methodFailed: 'Nabigo ang pag-save',
        checkoutFailed: 'Nabigo simulan ang pagbabayad',
        paidSuccess: 'Kumpleto ang bayad', paidPending: 'Pinoproseso ang bayad, mangyaring maghintay',
        cancelled: 'Kinansela ang pagbabayad',
      },
    },
  },
  zh: {
    mp: {
      uploaded: '登记:', cameraAdd: '拍照添加', selectFile: '选择文件', takePhoto: '拍照',
      guides: '课程指南', browseCourses: '查找课程', certNo: '结业证书编号:',
      meetingTime: '集合时间', experience: '相关工作经验', select: '请选择',
      showIdHistory: '显示历史身份证件', showCertHistory: '显示历史资格证书',
      sent: '已发送', idBack: '身份证件（反面）', idFront: '身份证件（正面）',
      certBack: '资格证书（反面）', certFront: '资格证书（正面）', cert: '资格',
      courseApplications: '课程报名记录', noGuides: '暂无课程指南',
      trainingGuides: '课程指南', applyCourse: '报名课程',
      completeToCert: '完成课程学习即可取得资格',
      invoiceInfo: '账单信息', bill: '账单', certType: '证书类型', set: '设置',
      prefDate3: '第3希望日期', prefDate2: '第2希望日期', prefDate1: '第1希望日期',
      memberSince: '注册日期:', pending: '待颁发', applicantInfo: '报名人信息',
      applied: '报名日期', noApplications: '暂无报名记录', applications: '报名记录',
      applicationCount: '报名数量', apply: '报名', submit: '申请',
      birthDate: '出生日期', done: '已完成', note: '注意事项', guide: '指南',
      valid: '有效', schedule: '日程', japan: '日本', newApplication: '新报名',
      branch: '支行名称:', bankInfo: '汇款账户信息', itemsToBring: '需携带物品',
      myCerts: '我的资格一览', noCerts: '暂无资格', certs: '我的资格',
      position: '职务', enterDates: '请输入希望日期（最多3个）',
      practicalConfirmed: '实操日程已确定', practicalReservation: '实操预约申请',
      bookPractical: '实操预约', cannotChange: '不可更改', map: '地图',
      total: '合计', accountType: '账户类型:', accountNo: '账号:', accountHolder: '账户名:',
      participantName: '学员姓名', completedCourses: '已完成课程',
      noCompletedCourses: '暂无已完成课程', completed: '已完成',
      courseSchedule: '学习日程', courseDate: '学习日期:', completionDate: '完成日期',
      noCourses: '暂无正在学习的课程', coursesInProgress: '正在学习的课程',
      watching: '学习中', watch: '学习中', watchCourse: '开始学习',
      acquired: '取得日期:', certsList: '已取得的资格·结业证书一览',
      changePhoto: '更换照片', allCompleted: '全部课程已完成',
      paidDate: '入账日期:', receipt: '收据', receiptDownloaded: '收据已下载', receiptFailed: '收据发行失败', notesQuestions: '备注·问题', noteLabel: '备注:',
      personalInfo: '个人信息', pendingCertNo: '结业证书编号未登记的课程:',
      certNumber: '结业证书编号', completionInfo: '结业信息', completionDateLabel: '结业年月日:',
      completedList: '已结业课程一览', created: '已创建',
      companyPhone: '公司电话', companyPostalCode: '公司邮编',
      companyInfo: '公司信息', companyName: '公司名称', companyAddress: '公司地址',
      venue: '会场', email: '邮箱', messageOptional: '留言（可选）',
      profileSettings: '个人资料设置', profilePhoto: '头像',
      clickForDetails: '点击查看详情', browseOnDemand: '查找点播课程',
      onDemandProgress: '点播课程的学习进度', no: '无',
      specialRequests: '如有要求请填写', yes: '有',
      viewPdf: '查看PDF', imageFormat: 'JPG、PNG格式（5MB以下）',
      bankName: '银行名称:', inProgress: '学习中', cancel: '取消',
      invoiceList: '账单一览', noInvoices: '暂无账单',
      idBackHistory: '身份证件（反面）历史', idFrontHistory: '身份证件（正面）历史',
      certBackHistory: '资格证书（反面）历史', certFrontHistory: '资格证书（正面）历史',
      cardCertNote: '卡片式证书的发放可能需另收手续费。详情请咨询事务局。',
      participantInfo: '学员信息',
      completeVideos: '请完成所有视频的观看',
      passQuizzes: '请通过所有测验',
      correctAnswer: '正确答案: ',
      pay: {
        selectMethod: '选择支付方式',
        bankTransfer: '银行转账', cash: '现金', creditCard: '信用卡',
        receiptRequest: '需要开具收据',
        confirmMethod: '确认此方式',
        cardNote: '将跳转至安全的Stripe支付页面',
        payByCard: '用卡支付',
        chosen: '已选择:',
        methodSaved: '已保存支付方式', methodFailed: '保存失败',
        checkoutFailed: '无法开始支付',
        paidSuccess: '支付完成', paidPending: '支付处理中，请稍候',
        cancelled: '支付已取消',
      },
    },
  },
};
